import { observable, action, autorun, computed } from 'mobx'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorage'
import sha1 from 'sha1'
import config from 'src/core/config'

const Api = {
  grant: `${config.host}/web/login/grant`,
  auth: `${config.host}/dash/login`,
  sms: `${config.host}/web/sms/2/get`,
  smsCheck: `${config.host}/web/admin/smscheck`,
  register: `${config.host}/web/admin/register`
}

const appId = 'cocktail'

export default class {
  @observable member = {
  }

  @observable loadingSms = false

  @observable loadingSubmit = false

  @action async login(query) {
    let map = {
      email: query.account,
      password: query.password,
    }
    this.loadingSubmit = true
    const d = await http.post(Api.auth, map) || {}
    this.loadingSubmit = false
    if (d && d.code === 0 && d.data && d.data !='') {
      localstorage.set('userToken', d.data)   
      return d
    } else {
      this.loadingSubmit = false
      return d
    }
  }

  @action getSms(mobile, cb) {
    let map = {
      mobile: mobile,
      oper_type: '0',
      country_code: '86'
    }
    this.loadingSms = true
    http.get(Api.sms, map, { appId }).then((data) => {
      this.loadingSms = false
      cb && cb(data)
    })
  }

  @action checkSms(data, cb) { // 验证短信
    let map = {
      mobile: data.account,
      oper_type: '0',
      smscode: data.smscode
    }
    this.loadingSubmit = true
    http.get(Api.smsCheck, map, { appId }).then((d) => {
      if (d.code !== 1) {
        cb && cb(d)
        return
      }
      let map = {
        account: data.account,
        account_type: 1,
        password: sha256(data.password),
        country_code: '86',
        authcode: d.res.authcode
      }
      http.get(Api.register, map, { appId }).then((data) => {
        this.loadingSubmit = false
        cb && cb(data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./store/oauth/login.js